import React from 'react';
import Main from './quiz/Main';
import './App.css';

function App() {
  return (
    <Main/>
  );
}

export default App;
